<template>
  <div
    class="yx-jxf-page main-layout predicted-item-page"
    v-loading="handleLoading"
  >
    <el-card shadow="never" class="box-inner box-bg">
      <c-title slot="header" title="军训服预订"></c-title>
      <div class="pb90">
        <div class="div-scroll">
          <el-row class="add-form">
            <el-form
              size="small"
              :model="handleData"
              ref="cForm"
              :rules="formRules"
              :label-width="'100px'"
              :disabled="disabled"
            >
              <!-- <el-form-item label="是否参加军训">
                <el-switch
                  v-model="isTrain"
                  active-text="是"
                  inactive-text="否"
                ></el-switch>
              </el-form-item> -->
              <div class="tips-container">
                <div class="tips">
                  <div class="title">
                    <i class="el-icon-info"></i><span>温馨提示</span>
                  </div>
                  <p>
                    按照国家相关规定，新生必须参加军训,参加军训请提交军训服尺码相关信息。
                  </p>
                </div>
              </div>
              <div>
                <el-col :span="24">
                  <c-form-item :formItems="formItems" ref="cFormItem" />
                </el-col>
                <el-col :span="24">
                  <span class="label">尺码对照表</span>
                  <img
                    src="../../../../assets/images/chima_new.png"
                    alt=""
                    class="chima-img"
                  />
                </el-col>
              </div>
              <!-- <div class="tips-container" v-else>
                <div class="template-download">
                  <a :href="link">点击下载申请表模板</a>
                </div>
                <div class="img-upload">
                  <div class="evidence-upload upload-item">
                    <div class="title">
                      <span class="red">*</span>上传申请表及佐证材料照片
                    </div>
                    <el-upload
                      action="/account/sys/static/upload"
                      list-type="picture-card"
                      accept="image/jpeg,image/jpg,image/png,image/bmp,image/gif"
                      :file-list="fileList"
                      :headers="{ token }"
                      :on-success="handlePictureSuccess"
                      :on-preview="handlePictureCardPreview"
                      :on-remove="handlePictureRemove"
                      :on-error="handleError"
                      :http-request="customUpload"
                    >
                      <i class="el-icon-plus" slot="default"></i>
                    </el-upload>
                  </div>
                </div>
              </div> -->
              <el-col :span="24" style="text-align: center; padding-top: 20px">
                <el-form-item label-width="0">
                  <slot name="other">
                    <el-button
                      type="primary"
                      @click="submit"
                      size="medium"
                      :disabled="isSubmit || disabled"
                      >提交</el-button
                    >
                  </slot>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </div>
      </div>
    </el-card>
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import Configs from "./data/jxf.js";
import MHandle from "@/mixins/MHandle.js";
import { guid } from "@/libs/tools.js";
import mUpload from "@/mixins/MUpload.js";
import { mapState } from "vuex";
let mHandle = MHandle({
  handleGetPathNoparam: "/welcome-forecast/clothing/myInfo",
  handleInsertPath: "/welcome-forecast/clothing/save",
  handleUpdatePath: "/welcome-forecast/clothing/update",
  handleDownLoadPath: "",
  handleData: {
    studentName: "",
    idCard: "",
    height: "",
    weight: "",
    dressSize: "",
    shoeSize: "",
    remark: "",
  },
});
export default {
  mixins: [mHandle, mUpload],
  provide() {
    return {
      cForm: this,
    };
  },
  data() {
    let { jxfFormItems, jxfFormRules } = Configs(this);
    return {
      formItems: jxfFormItems,
      formRules: jxfFormRules,
      studentId: "",
      value: {},
      isTrain: true,
      token: "",
      link: "http://yx.ezu.cn/static/welcome/%E9%84%82%E5%B7%9E%E8%81%8C%E4%B8%9A%E5%A4%A7%E5%AD%A6%E5%86%9B%E8%AE%AD%E5%87%8F%E8%AE%AD%E5%AF%B9%E8%B1%A1%E7%94%B3%E8%AF%B7%E8%A1%A8.doc",
      formFileList: [],
      fileList: [],
      status: "",
      dialogVisible: false,
      dialogImageUrl: "",
      applyInfo: {},
      isApply: false,
      isSubmit: false,
      isOrNot: 1,
      pictureUrl: [],
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE"]),
    disabled() {
      let status = this.$route.params.status;
      return status == 2 ? true : false;
    },
  },
  watch: {
    handleData: {
      handler(val) {
        this.value = val;
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.token = localStorage.getItem("token");
    this.studentId = JSON.parse(localStorage.getItem("userInfo")).studentId;
    this.forecastLinkId = this.$route.params.id;
    this.status = this.$route.params.status;
    this.isOrNot =
      this.$route.params.isOrNot == "null"
        ? 1
        : Number(this.$route.params.isOrNot);
    // 获取军训服信息
    this.handleGetNoparam();
    // 获取申请表信息
    // this.getApplyInfo();

    // 非审批状态时是参加军训,审批状态时是申请不参加军训
    // if (this.isOrNot == 1) {
    //   this.isTrain = true;
    // } else {
    //   this.isTrain = false;
    // }
  },
  mounted() {},
  methods: {
    // 获取个人军训服信息
    getJxfInfo() {
      this.$http.get("/welcome-forecast/clothing/myInfo").then((res) => {
        if (res.code == this.SUCCESS_CODE) {
          this.jxfInfo = res.data;
        } else {
          this.$message.error(`${res.msg}`);
        }
      });
    },
    // 获取军训减免信息
    getApplyInfo() {
      this.$http.get("/welcome-forecast/train/apply/myInfo").then((res) => {
        if (res.code == this.SUCCESS_CODE) {
          if (res.data) {
            this.applyInfo = res.data;
            // if (res.data.formUrl) {
            //   this.formFileList = [{ url: res.data.formUrl }];
            // }
            if (res.data.pictureUrl && res.data.pictureUrl.length) {
              res.data.pictureUrl.forEach((item) =>
                this.fileList.push({ url: item, name: item })
              );
              this.pictureUrl = [...this.fileList];
            }
          }
        } else {
          this.$message.error(`${res.msg}`);
        }
      });
    },
    handleBeforeFn(data) {
      data.forecastLinkId = this.forecastLinkId;
      data.studentId = this.studentId;
      data.pictureUrl = this.pictureUrl.map((item) => item.url);
    },
    submit() {
      // console.log(this.handleData);
      if (!this.isTrain) {
        this.apply();
      } else {
        this.$refs.cForm.validate((valid) => {
          if (valid) {
            this.$confirm("请确认无误后提交，是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.isSubmit = true;
                if (this.handleData.id) {
                  this.handleUpdate();
                } else {
                  this.handleInsert();
                }
              })
              .catch(() => {});
          } else {
            return false;
          }
        });
      }
    },
    // 申请表上传成功
    handleFormSuccess(res, file, fileList) {
      // console.log(file);
      if (res.code == this.SUCCESS_CODE) {
        file.url = res.data.url;
        this.formFileList = fileList;
      }
    },
    // 佐证材料上传成功
    handlePictureSuccess(res, file, fileList) {
      // console.log(this.fileList);
      if (res.code == this.SUCCESS_CODE) {
        file.url = res.data.url;
        this.fileList = fileList;
      }
    },
    // 图片预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 删除申请表图片
    handleFormRemove(file, fileList) {
      console.log(fileList);
      this.formFileList = fileList;
    },
    // 删除佐证材料图片
    handlePictureRemove(file, fileList) {
      this.fileList = fileList;
      let index = this.pictureUrl.findIndex((item) => item.name == file.name);
      this.pictureUrl.splice(index, 1);
    },
    // 申请表上传多张时提醒
    handleExceed(file, fileList) {
      this.$message.warning("只能上传一张图片，请先删除后上传！");
    },
    handleError(err) {
      this.$message.error("上传失败，" + err);
    },
    apply() {
      if (this.pictureUrl && this.pictureUrl.length) {
        this.$confirm("请确认无误后提交，是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            // let formUrl = this.formFileList[0].url;
            // this.applyInfo.formUrl = formUrl;
            let pictureUrl = this.pictureUrl.map((item) => item.url);
            this.applyInfo.forecastLinkId = this.forecastLinkId;
            this.applyInfo.pictureUrl = pictureUrl;
            this.applyInfo.studentId = this.studentId;
            console.log(this.applyInfo);
            // 判断是否是驳回修改
            if (this.applyInfo.id) {
              this.updateApply(this.applyInfo);
            } else {
              this.saveApply(this.applyInfo);
            }
          })
          .catch(() => {});
      } else {
        this.$alert("请上传申请表及佐证材料", "提示", {
          confirmButtonText: "确定",
          type: "warning",
        });
      }
    },
    saveApply(params) {
      this.isSubmit = true;
      this.handleLoading = true;
      this.$http
        .post("/welcome-forecast/train/apply/save", params)
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.$message.success("提交成功");
            // this.$router.go(-1);
            this.$router.replace("/welcome/student/predicted");
          } else {
            this.$message.error("提交失败");
          }
          this.isSubmit = false;
          this.handleLoading = false;
        })
        .catch((err) => {
          this.isSubmit = false;
          this.handleLoading = false;
          this.$message.error("提交失败", err);
        });
    },
    updateApply(params) {
      console.log(params);
      this.isSubmit = true;
      this.handleLoading = true;
      this.$http
        .post("/welcome-forecast/train/apply/update", params)
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.$message.success("提交成功");
            // this.$router.go(-1);
            this.$router.replace("/welcome/student/predicted");
          } else {
            this.$message.error("提交失败");
          }
          this.isSubmit = false;
          this.handleLoading = false;
        })
        .catch((err) => {
          this.isSubmit = false;
          this.handleLoading = false;
          this.$message.error("提交失败", err);
        });
    },
    handleAfterFn() {
      this.isSubmit = false;
      // this.$router.go(-1);
      this.$router.replace("/welcome/student/predicted");
    },
    // 自定义上传方法
    customUpload(e) {
      console.log(e);
      let self = this;
      var file = e.file;
      var fileName = guid();
      self.obsUpload(file, fileName, this.afterObsUpload);
    },
    afterObsUpload(obsUrl, file) {
      this.pictureUrl.push({ url: obsUrl, name: file.name });
    },
  },
};
</script>
